/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import styled from '@emotion/styled';
import { Link as BaseLink, LinkProps as BaseLinkProps } from 'theme-ui';

export const LinkButton = styled(BaseLink)<BaseLinkProps>`
  font-family: 'cinzel', 'Times', 'Times New Roman', serif;
  display: inline-block;
  vertical-align: middle;
  padding: 0.5em 0.8em;
  border-radius: 0;
  text-align: center;
  cursor: pointer;
  color: #411102;
  font-family: 'cinzel', 'Times', 'Times New Roman', serif;
  font-weight: bold;
  text-decoration: none;
  text-transform: uppercase;
  text-shadow: 0 0.0625rem 0.0625rem rgba(236, 237, 238, 0.75);
  background: linear-gradient(-180deg, #e6b226 0%, #d87b19 100%);
  border-bottom: 0.1875rem solid #9f4000;
  border-left: 0.1875rem solid #f0d079;
  border-right: 0.1875rem solid #9f4000;
  border-top: 0.1875rem solid #f0d079;
`;
